<template>
  <div
    class="boder-box transition-outline group flex h-[62px] cursor-pointer gap-2 rounded-md bg-gray-600 p-2 outline outline-2 outline-offset-[-2px] outline-transparent transition duration-300 hover:bg-gray-800 hover:outline-accent-1"
    @click="showNotification"
  >
    <div
      v-for="column in columns"
      :key="column.id"
      class="rounded-sm border border-dashed border-gray-200 bg-gray-500 transition duration-300 group-hover:border-gray-50"
      :style="{ width: column.width }"
    ></div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useNotificationsStore } from "@/stores/notifications";
  import { useI18n } from "vue-i18n";

  const props = defineProps({
    type: {
      type: String,
      default: "100",
    },
    disableNotification: {
      type: Boolean,
      default: false,
    },
  });

  const notificationsStore = useNotificationsStore();
  const { t } = useI18n();

  const columns = computed(() => {
    type Column = {
      id: number;
      width: string;
    };

    const columns: Column[] = [];

    const partials = props.type.split("-");

    let index = 0;
    partials.forEach((partial) => {
      columns.push({
        id: index++,
        width: partial + "%",
      });
    });

    return columns;
  });

  function showNotification() {
    if (!props.disableNotification) {
      notificationsStore.createNotification({
        type: "info",
        text: t("blocks.drag_structure"),
      });
    }
  }
</script>

<style lang="scss"></style>
